import QueryParameterBuilder from '@/lib/query-parameter/QueryParameterBuilder';
import { deliveryChargeAreaApi } from '@/api';
export default {
    async getDeliveryChargeAreaList({ hubId = '', areaName = '' }) {
        const params = new QueryParameterBuilder();
        if (areaName) {
            params.add('areaName', areaName);
        }
        const response = await deliveryChargeAreaApi.getDeliveryChargeAreaList(hubId, params.build());
        return response.data;
    },
    async getDeliveryChargeArea({ hubId = '', areaId = 0, }) {
        const response = await deliveryChargeAreaApi.getDeliveryChargeArea(hubId, areaId);
        return response.data;
    },
    async postDeliveryChargeArea({ hubId = '', areaInfo = {}, }) {
        const response = await deliveryChargeAreaApi.postDeliveryChargeArea(hubId, areaInfo);
        return response.data;
    },
    async putDeliveryChargeArea({ hubId = '', areaId = 0, areaName = '', }) {
        const response = await deliveryChargeAreaApi.putDeliveryChargeArea(hubId, areaId, {
            areaName,
        });
        return response.data;
    },
    async deleteDeliveryChargeArea({ hubId = '', areaId = 0, }) {
        const response = await deliveryChargeAreaApi.deleteDeliveryChargeArea(hubId, areaId);
        return response.data;
    },
};
